module.exports = __webpack_public_path__ + "static/img/58fe67feef07eb345964188e794ad840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro_banner.png
// module id = s/4E
// module chunks = 1